import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';

const HOME = { admin: '/admin/dashboard', cleaner: '/cleaner/dashboard' };

// Admin ⇄ Cleaner switch for accounts the server authorizes for both views
export const ViewSwitch = ({ dark = false }) => {
  const { user, canSwitchViews, switchView } = useAuth();
  const { pathname, search } = useLocation();
  const [busy, setBusy] = useState(false);
  if (!canSwitchViews) return null;
  const current = user?.acting_view || 'admin';

  const go = async (view) => {
    if (view === current || busy) return;
    setBusy(true);
    try {
      sessionStorage.setItem(`gg_return_${current}`, pathname + search);
      await switchView(view);
      window.location.assign(sessionStorage.getItem(`gg_return_${view}`) || HOME[view]);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not switch views');
    } finally { setBusy(false); }
  };

  const base = dark ? 'bg-zinc-900 border-zinc-700' : 'bg-[#f1f0ea] border-[#dcded2]';
  return (
    <div className={`inline-flex rounded-lg border p-1 gap-1 ${base}`} role="group" aria-label="Workspace view" data-testid="view-switch">
      {(user.available_views || []).map((v) => (
        <button key={v} type="button" onClick={() => go(v)} disabled={busy} aria-pressed={v === current}
          className={`px-3 py-1.5 rounded-md text-xs font-semibold capitalize transition-colors ${v === current ? 'bg-[#252a20] text-white' : dark ? 'text-zinc-400 hover:text-white' : 'text-[#6e7a55] hover:bg-white'}`}
          data-testid={`view-switch-${v}`}>{v}</button>
      ))}
    </div>
  );
};

export default ViewSwitch;
